<template>
  <div class="img-container row">
    <div v-if="hasImage" class="col-12 no-pad-both">
      <div class="img-change-btn img-change-btn-left noselect" v-if="currentImageNumber > 0" @click="currentImageNumber--">
        <span class="material-icons" aria-label="Vis forrige billede" role="button">chevron_left</span>
      </div>

      <template v-for="(image,index) in imageData">
    		<div :id="'img-'+index" :class="'img-wrap img-'+index">

          <img :src="'https://apps.odenserundt.dk/media/images/'+image.resolution+'/'+image.src" class="img-small" :alt="image.imageName" v-show="index == currentImageNumber">

    			<span class="img-credit" v-if="image.imgCredit != ''" v-show="index == currentImageNumber">Foto: {{ image.imgCredit }}</span>

    		</div>
      </template>

      <div class="img-change-btn img-change-btn-right noselect" v-if="imageData.length > 1 && currentImageNumber+1 != imageData.length" @click="currentImageNumber++">
        <span class="material-icons" aria-label="Vis næste billede" role="button">chevron_right</span>
      </div>

    </div>
    <div v-else>

      <img class="img-small" src="/img/missingImg.jpg" alt="Intet billede for dette sted">
      <!-- <span class="missing-img-text">
        <p><strong>Ooops!</strong><br>Vi mangler et billede af dette sted</p>
        <p><strong>Hjælp os!</strong><br>Tag et billede og send det til os på <a href="mailto:odenserundt@odense.dk">OdenseRundt@odense.dk</a> Tak :-)</p>
      </span> -->

    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      currentImageNumber: 0,
      missingImgLink: '',
      hasImage: true,
    }
  },
  props: {
    imageData: {
      required: true,
      default: () => [],
    },
  },
  watch: {
    imageData() {
      this.checkForImage();
    }
  },
  created() {
    this.checkForImage();
  },
  methods: {
    checkForImage() {
      if(this.$props.imageData.length != 0) {
        if(this.$props.imageData[0].hasImage == false) {
          this.hasImage = false;
          this.missingImgLink = '/contact/image/'+this.$props.imageData[0].placeId;
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .img-container {
    position: relative;
    overflow: hidden;
  }

  .img-container .img-small {
    width: 100%;
    height: 100%;
  }

  .img-wrap {
    position: relative;
  }

  .img-credit {
  	position: absolute;
    bottom: 0px;
    left: 0px;
    background-color: rgba(000,000,000, 0.3);
    padding: 0px 5px;
    color: #f8f8f8;
  }

  .img-change-btn {
  	position: absolute;
  	z-index: 800;
  	top: 50%;
  	margin-top: -30px;
  	color: #565656;
  	display: block;
    cursor: pointer;
  }

  .img-change-btn .material-icons {
  	font-size: 40px !important;
  	display: block;
  	margin: 10px;
  	background-color: rgba(255,255,255,0.4);
  	border-radius: 30px;
  }

  .missing-img-text {
  	position: absolute;
  	z-index: 100;
  	left: 50%;
  	margin-left: -150px;
  	width: 300px;
  	letter-spacing: normal;
  	top: 10%;
  }

  @media screen and (min-width: 767px) {
  	.missing-img-text {
  		width: auto;
  		transform: translateY(50%) translateX(-25%);
  	}
  }

  /*Landscape - XS*/
  @media screen and (max-width: 767px) and (orientation: landscape) {
  	.img-change-btn-left {
  		left: -10px;
  	}
  	.img-change-btn-right {
  		right: -10px;
  	}
  }
  /*Landscape - MD*/
  @media screen and (min-width: 992px) and (orientation: landscape) {
  	.img-change-btn-left {
  		left: 0px;
  	}
  	.img-change-btn-right {
  		right: 0px;
  	}
  }
  /*Portrait - XS*/
  @media screen and (max-width: 767px) and (orientation: portrait) {
  	.img-change-btn-left {
  		left: -5px;
  	}
  	.img-change-btn-right {
  		right: -5px;
  	}
  }
</style>
